/** Shared config for blanket detailed information (Phase 9.9F). */

export const BLANKET_DETAILED_INFO_CONFIG = {
  creation: {
    surface: "creation",
    title: "Detailed Information",
  },
  historic: {
    surface: "historic",
    title: "Detailed Information",
  },
};
